import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EventHistoryService } from "src/app/_services/event-history.service";
import { GetAllEventTypes, GetAllEventTypesError, GetAllEventTypesSuccess, GetCurrentPageNumber, GetCurrentPageNumberError, GetCurrentPageNumberSuccess, GetEventHistoryRecordLength, GetEventHistoryRecordLengthError, GetEventHistoryRecordLengthSuccess, GetEventHistoryRecords, GetEventHistoryRecordsError, GetEventHistoryRecordsSuccess, SaveLoginHistory, SaveLoginHistoryError, SaveLoginHistorySuccess, UpdateEventHistoriesTable, UpdateEventHistoriesTableError, UpdateEventHistoriesTableSuccess } from "./event-history.action";
import { catchError, map, switchMap } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { EventHistoryRecords, EventTypes } from "src/app/_models/EventDto";
import { EventTypeService } from "src/app/_services/event-type.service";

@Injectable()
export class EventHistoryEffects {
  constructor(
    private actions$: Actions,
    private eventTypesService: EventTypeService,
    private eventHistoryService: EventHistoryService
  ) {}

  public getAllEventTypesEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetAllEventTypes),
      switchMap(() => 
        this.eventTypesService.getAllEventTypes$()
        .pipe(
          map((result: EventTypes[]) => {
            return GetAllEventTypesSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetAllEventTypesError({error: error}));
          })
        )
      )
    )
  );

  public saveLoginHistoryEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SaveLoginHistory),
      switchMap((payload) => 
        this.eventHistoryService.saveLoginEvent$(payload.loginHistory)
        .pipe(
          map((result: boolean) => {
            return SaveLoginHistorySuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(SaveLoginHistoryError({error: error}));
          })
        )
      )
    )
  );

  public getEventHistoriesRecordsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetEventHistoryRecords),
      switchMap((payload) => 
        this.eventHistoryService.getEventHistoriesRecords$(
          payload.userId,
          payload.pageNumber,
          payload.isInitialLoad
        )
        .pipe(
          map((result: EventHistoryRecords[]) => {
            return GetEventHistoryRecordsSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetEventHistoryRecordsError({error: error}));
          })
        )
      )
    )
  );

  public updateEventHistoriesTableEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateEventHistoriesTable),
      switchMap((payload) => 
        this.eventHistoryService.updateEventHistoriesTable$(payload.param, payload.userId)
        .pipe(
          map((result: boolean) => {
            return GetEventHistoryRecords({
              isInitialLoad: false,
              pageNumber: payload.param.pageIndex,
              userId: payload.userId
            })
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UpdateEventHistoriesTableError({error: error}));
          })
        )
      )
    )
  );

  public getEventHistoryRecordLength$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetEventHistoryRecordLength),
      switchMap(() => 
        this.eventHistoryService.getEvenHistoryRecordLength$()
        .pipe(
          map((result: number) => {
            return GetEventHistoryRecordLengthSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetEventHistoryRecordLengthError({error: error}));
          })
        )
      )
    )
  );

  public getEventHistorySessionCurrentPageNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetCurrentPageNumber),
      switchMap((payload) => 
        this.eventHistoryService.getCurrentPageNumber$(payload.pageIndex)
        .pipe(
          map((result: number) => {
            return GetCurrentPageNumberSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetCurrentPageNumberError({error: error}));
          })
        )
      )
    )
  );
}